import { useMutation } from '@tanstack/react-query'
import { updateEarningsDistribution } from 'services/RewardsService'
import { BaseErrorResponse } from 'types/beneficiaries'
import { type UpdateEarningsDistributionRequest } from 'types/rewards'

export const useUpdateEarningsDistributionMutation = () =>
  useMutation<void, BaseErrorResponse, UpdateEarningsDistributionRequest>({
    mutationFn: updateEarningsDistribution,
  })
